module.exports = __webpack_public_path__ + "img/restaurant_sign.e1717e4d.png";